import { IUser } from '../interfaces';
import { INotificationSetting } from '../interfaces/notification-setting';
import { User } from './user';

export class NotificationSetting implements INotificationSetting {
  id?: number;
  setting: string;
  sendSms?: boolean;
  sendPush?: boolean;
  sendEmail?: boolean;
  user?: User;

  constructor(data?: INotificationSetting) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: IUser): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }
  }
}
